import template from './furniture-presence.jade';
import furniturePresenceOptions from '../../../enums/yes-no-optional';

export default angular
    .module('cian.addForm.furniturePresence', [])
    .directive('cianAfAboutObjectFurniturePresence', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = furniturePresenceOptions;
        },
        controllerAs: 'furniturePresence',
        template,
    }))
    .name;
